import React from "react";
import { Card, CardHeader, CardContent } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Cell,
  ResponsiveContainer,
  Label,
} from "recharts";
import useEnrollmentHook from "../hooks/EnrollmentHook";

const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const HeadCount = ({ schoolId }) => {
  const { data, loading, error } = useEnrollmentHook(schoolId);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading data</div>;
  }

  // Generate an array of random colors for each bar
  const colors = data.map(() => getRandomColor());

  // Find the maximum value in the dataset
  const maxValue = Math.max(...data.map((d) => d.Head_Count));

  return (
    <Card>
      <CardHeader
        title="Head Count"
        sx={{ backgroundColor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="Year">
              <Label value="Year" offset={-5} position="insideBottom" />
            </XAxis>
            <YAxis
              tickFormatter={(value) => value.toLocaleString()}
              domain={[0, maxValue]}
              tickCount={10}
            >
              <Label value="# Enrolled" angle={-90} position="insideLeft" />
            </YAxis>
            <Tooltip />
            <Bar dataKey="Head_Count">
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors[index]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default HeadCount;
